import React from 'react'

/** Scorecard surface. Legacy panels already pad their own content, so they take this and not the shell padding. */
export const PLOT_CARD_FILL = 'var(--slide-card-bg)'

export const PLOT_CARD_RADIUS = 16

export const PLOT_CARD_SURFACE: React.CSSProperties = {
  borderRadius: PLOT_CARD_RADIUS,
  background: PLOT_CARD_FILL,
}

/** Exhibit inset. 40 + 20 vertical, 32 horizontal. The height measure subtracts the vertical pair. */
export const PLOT_CARD_PAD_TOP = 40
export const PLOT_CARD_PAD_X = 32
export const PLOT_CARD_PAD_BOTTOM = 20
export const PLOT_CARD_VERTICAL_PADDING = PLOT_CARD_PAD_TOP + PLOT_CARD_PAD_BOTTOM

export interface PlotCardProps {
  children: React.ReactNode
  testId?: string
}

/** The Diagnostic Scorecard panel: grey fill, radius 16, and the scorecard inset. */
export function PlotCard(props: PlotCardProps) {
  const { children, testId = 'plot-card' } = props

  return (
    <div
      data-testid={testId}
      style={{
        ...PLOT_CARD_SURFACE,
        boxSizing: 'border-box',
        padding: `${PLOT_CARD_PAD_TOP}px ${PLOT_CARD_PAD_X}px ${PLOT_CARD_PAD_BOTTOM}px`,
        minWidth: 0,
      }}
    >
      {children}
    </div>
  )
}
